import type { Training } from './vuex';

export default {
  training: null as null | Training,
};
